import { ApiPermissions } from "../cefi";

export type APIKeyDefinition = {
  apiKey: string;
  apiSecret: string;
  password?: string;
  name: string;
  mode: ApiPermissions[];
  cex: string;
  active: boolean;
  ipDependant: boolean;
};
